<div *ngIf="excessData" class="excess-selection-container">
  <div class="excess-title">{{ excessData.title }}</div>
  <div class="excess-desc">{{ excessData.desc }}</div>
  <ui-radio-list
    [list]="radioItems"
    [value]="selectedValue"
    (selectionChange)="onExcessChange($event)"
  ></ui-radio-list>
</div>
